<script lang="ts">
  import ValInputField from "../../ValInputField.svelte";
  import { Form, Validate } from "../../../lib/validation_next";
  import CustomButton from "../../CustomButton.svelte";
  import { Toast } from "$components";
  import { type CreateSpotShare } from "../../../../apis/parkito";

  export let spotId: string;
  export let agreementSpotId: string | null = null;
  export let submitClicked: (data: CreateSpotShare) => void;
  export let abortClicked: () => void;

  let fieldSpotSharingEmail = Form.field(
    Validate.required().and(Validate.email()),
  );
  let fieldSpotSharingDateFrom = Form.field(
    Validate.required()
      .and(Validate.len(0, 64))
      .map((v) => new Date(v ?? "").toISOString()),
  );
  let fieldSpotSharingDateTo = Form.field(
    Validate.optional(
      Validate.len(0, 64).map((v) => new Date(v ?? "").toISOString()),
    ),
  );

  let formAddSpotSharing = Form.object({
    email: fieldSpotSharingEmail,
    dateFrom: fieldSpotSharingDateFrom,
    validUntil: fieldSpotSharingDateTo,
  });

  const addSpotSharing = async () => {
    if (!$formAddSpotSharing.res.isOk()) {
      Toast.error("Formuläret innehåller fel");
      return;
    }
    const form = {
      ...$formAddSpotSharing.res.value,
      spotId,
      agreementSpotId,
    } as CreateSpotShare;

    submitClicked(form);
  };
</script>

<div>
  <div class="px-[24px] py-[16px] max-mobile:px-[16px]">
    <p>
      <ValInputField
        name="email"
        field={fieldSpotSharingEmail}
        placeholder="Ange e-postadress"
        label="E-postadress*"
      />
      <ValInputField
        name="date-from"
        field={fieldSpotSharingDateFrom}
        placeholder="Giltig från"
        label="Giltig från*"
        type="date"
        customClass="pt-[8px]"
      />
      <ValInputField
        name="date-to"
        field={fieldSpotSharingDateTo}
        placeholder="Giltig till"
        label="Giltig till"
        type="date"
        customClass="pt-[8px]"
      />
    </p>
    <div class="flex pt-[24px] justify-end">
      <CustomButton type="ghost" onClick={abortClicked} customClass="mr-[8px]"
      >Avbryt</CustomButton>
      <CustomButton
        disabled={!$formAddSpotSharing.res.isOk()}
        onClick={addSpotSharing}
        customClass="w-[200px]"
      >Skapa ny</CustomButton>
    </div>
  </div>
</div>
